import { css } from '@nobia/zeus-components/lib/styled'

const fontUrl =
  'https://res.cloudinary.com/dgg9enyjv/raw/upload/v1525075261/keittiomaailma/fonts/'

const keittiomaailmaFonts = css`
  @font-face {
    font-family: 'Apercu';
    src: url(${fontUrl}apercu-regular.woff) format('woff'),
      url(${fontUrl}apercu_regular_pro.otf) format('opentype');
    font-weight: 400;
  }
  @font-face {
    font-family: 'Apercu';
    src: url(${fontUrl}apercu_bold_pro.otf) format('opentype');
    font-weight: 700;
  }
`

export default keittiomaailmaFonts
